class NoopSignal {
	add(_listener: (...args: unknown[]) => void): void {
		// Intentionally empty.
	}
}

export class Spector {
	public onCapture = new NoopSignal();

	captureCanvas(
		_canvas: HTMLCanvasElement,
		_commandCount = 0,
		_quickCapture = false,
		_fullCapture = false,
	): void {
		// Intentionally empty.
	}

	captureNextFrame(_canvas: HTMLCanvasElement): void {
		// Intentionally empty.
	}

	getFps(): number {
		return 0;
	}

	log(message: string): string {
		return message;
	}

	startCapture(
		_canvas: HTMLCanvasElement,
		_commandCount = 0,
		_quickCapture = false,
		_fullCapture = false,
	): void {
		// Intentionally empty.
	}

	stopCapture(): Record<string, never> {
		return {};
	}

	getResultUI(): { display: (capture: unknown) => void } {
		return {
			display: (_capture: unknown) => {
				// Intentionally empty.
			},
		};
	}
}

const spectorShim = { Spector };

export default spectorShim;
